export const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_c16bfcd0-743d-419c-973f-54c5301650f1/artifacts/kwpi13r5_8143438e-9987-4a19-9244-5fd4010fa7b2.png";

export const CONTACT = {
  ownerPhone: "425-321-8785",
  dispatchPhone: "657-922-3201",
  email: "lorisomartin@hotmail.com",
  website: "everettsamstreescape.com",
};

export const MEDIA = {
  hero: "https://images.unsplash.com/photo-1609672743222-48ccfb5c3b91?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDN8MHwxfHNlYXJjaHwyfHxtYWplc3RpYyUyMHRyZWUlMjBzdW5zZXR8ZW58MHx8fHwxNzgzNDU4ODg0fDA&ixlib=rb-4.1.0&q=85",
  about: "https://images.unsplash.com/photo-1754321902809-5c21cbc67228?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTJ8MHwxfHNlYXJjaHwzfHxhcmJvcmlzdCUyMGNsaW1iaW5nJTIwdHJlZXxlbnwwfHx8fDE3ODM0NTg4ODR8MA&ixlib=rb-4.1.0&q=85",
  treeRemoval: "https://images.unsplash.com/photo-1684332666088-f35b252b5aca?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NDh8MHwxfHNlYXJjaHwxfHxjaGFpbnNhdyUyMHRyZWUlMjBjdXR0aW5nfGVufDB8fHx8MTc4MzQ1ODg4NHww&ixlib=rb-4.1.0&q=85",
  emergency: "https://images.pexels.com/photos/35089307/pexels-photo-35089307.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  barkTexture: "https://images.pexels.com/photos/18611106/pexels-photo-18611106.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
};

export const SERVICES = [
  {
    id: "tree-removal",
    title: "Tree Removal",
    desc: "Safe, precise removal of hazardous, dead, or unwanted trees of any size — protecting your property every step of the way.",
    icon: "Axe",
    image: MEDIA.treeRemoval,
    featured: true,
  },
  {
    id: "trimming-pruning",
    title: "Trimming & Pruning",
    desc: "Expert crown thinning, shaping, and deadwood removal that keeps your trees healthy, beautiful, and structurally sound.",
    icon: "Scissors",
  },
  {
    id: "stump-grinding",
    title: "Stump Grinding & Removal",
    desc: "Grind unsightly stumps below grade and reclaim your yard — no more tripping hazards or regrowth.",
    icon: "Disc3",
  },
  {
    id: "emergency-storm",
    title: "Emergency & Storm Damage",
    desc: "24/7 rapid response for fallen limbs and storm-damaged trees. When disaster strikes, we're on the way.",
    icon: "CloudLightning",
    image: MEDIA.emergency,
    featured: true,
  },
  {
    id: "land-clearing",
    title: "Land Clearing",
    desc: "Full lot and brush clearing for new construction, development, or reclaiming overgrown property.",
    icon: "Trees",
  },
];

export const TRUST_BADGES = [
  { icon: "ShieldCheck", label: "Licensed & Insured" },
  { icon: "Clock", label: "24/7 Emergency Service" },
  { icon: "Users", label: "Family Owned & Operated" },
  { icon: "Award", label: "Certified Arborists" },
];

export const PROCESS = [
  { step: "01", title: "Request Estimate", desc: "Fill out our quick form or call us directly — it's completely free." },
  { step: "02", title: "On-Site Assessment", desc: "Our arborists evaluate your trees and provide a transparent quote." },
  { step: "03", title: "Expert Execution", desc: "Our crew completes the job safely, on schedule, and to spec." },
  { step: "04", title: "Clean & Done", desc: "We haul away debris and leave your property spotless." },
];

export const TESTIMONIALS = [
  {
    name: "Marcus R.",
    location: "Everett, WA",
    quote: "Everett's crew took down three massive firs leaning over my house without a single scratch to the property. True professionals.",
    rating: 5,
  },
  {
    name: "Danielle P.",
    location: "Denver, CO",
    quote: "A storm dropped a huge limb on our garage at midnight. They had a team out before sunrise. Lifesavers — literally.",
    rating: 5,
  },
  {
    name: "Anthony G.",
    location: "Austin, TX",
    quote: "Fair pricing, spotless cleanup, and my trees have never looked healthier. I won't call anyone else.",
    rating: 5,
  },
];

export const STATS = [
  { value: "10K+", label: "Trees Serviced" },
  { value: "Local", label: "Everett & Nearby" },
  { value: "24/7", label: "Emergency Ready" },
  { value: "100%", label: "Satisfaction Focus" },
];

export const SERVICE_OPTIONS = [
  "Tree Removal",
  "Trimming & Pruning",
  "Stump Grinding & Removal",
  "Emergency / Storm Damage",
  "Land Clearing",
  "Not Sure — Need Advice",
];

export const SOCIALS = [
  { name: "Facebook", icon: "Facebook", url: "#" },
  { name: "Instagram", icon: "Instagram", url: "#" },
  { name: "YouTube", icon: "Youtube", url: "#" },
  { name: "TikTok", icon: "TikTok", url: "#" },
];

export const GALLERY = [
  { url: "https://images.pexels.com/photos/6218318/pexels-photo-6218318.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=700", title: "High Removal, Blue Skies", category: "Tree Removal" },
  { url: "https://images.pexels.com/photos/34674271/pexels-photo-34674271.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=700", title: "Climbing Chainsaw Work", category: "Tree Removal" },
  { url: "https://images.unsplash.com/photo-1781297770538-605dccdc52a7?crop=entropy&cs=srgb&fm=jpg&q=80&w=700", title: "Palm Crown Cleaning", category: "Pruning" },
  { url: "https://images.unsplash.com/photo-1765064520245-2baac5e82689?crop=entropy&cs=srgb&fm=jpg&q=80&w=700", title: "Tall Canopy Pruning", category: "Pruning" },
  { url: "https://images.unsplash.com/photo-1631300313270-227604e71ea5?crop=entropy&cs=srgb&fm=jpg&q=80&w=700", title: "Limb-by-Limb Precision", category: "Pruning" },
  { url: "https://images.unsplash.com/photo-1727818899530-5a3bee908607?crop=entropy&cs=srgb&fm=jpg&q=80&w=700", title: "Crane-Assisted Removal", category: "Tree Removal" },
  { url: "https://images.unsplash.com/photo-1657730391002-bf55ff069a80?crop=entropy&cs=srgb&fm=jpg&q=80&w=700", title: "Roadside Take-Down", category: "Tree Removal" },
  { url: "https://images.unsplash.com/photo-1754322449185-31f56117ed87?crop=entropy&cs=srgb&fm=jpg&q=80&w=700", title: "Deadwood Clearing", category: "Pruning" },
  { url: "https://images.unsplash.com/photo-1626828476637-5bd713ef9f22?crop=entropy&cs=srgb&fm=jpg&q=80&w=700", title: "Technical Rigging", category: "Storm Damage" },
  { url: "https://images.unsplash.com/photo-1765064520296-1e56ebb82e17?crop=entropy&cs=srgb&fm=jpg&q=80&w=700", title: "Structural Thinning", category: "Pruning" },
  { url: "https://images.unsplash.com/photo-1621532860549-e5ebe6da26b6?crop=entropy&cs=srgb&fm=jpg&q=80&w=700", title: "Stump Ground Flush", category: "Stump Grinding" },
  { url: "https://images.unsplash.com/photo-1534686249231-317acc98e634?crop=entropy&cs=srgb&fm=jpg&q=80&w=700", title: "Old Stump Removal", category: "Stump Grinding" },
  { url: "https://images.unsplash.com/photo-1591497108596-436c1a1a5c8e?crop=entropy&cs=srgb&fm=jpg&q=80&w=700", title: "Tree-On-Vehicle Rescue", category: "Storm Damage" },
  { url: "https://images.unsplash.com/photo-1645466996104-22f4b160331b?crop=entropy&cs=srgb&fm=jpg&q=80&w=700", title: "Uprooted Giant Cleanup", category: "Storm Damage" },
];

export const GALLERY_CATEGORIES = ["All", "Tree Removal", "Pruning", "Stump Grinding", "Storm Damage"];

export const BEFORE_AFTER = [
  {
    label: "Storm Damage Recovery",
    before: "https://images.unsplash.com/photo-1591497108596-436c1a1a5c8e?crop=entropy&cs=srgb&fm=jpg&q=80&w=800",
    after: "https://images.unsplash.com/photo-1691315039493-0d627a38a7c4?crop=entropy&cs=srgb&fm=jpg&q=80&w=800",
  },
  {
    label: "Overgrown to Manicured",
    before: "https://images.pexels.com/photos/17972815/pexels-photo-17972815.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=600&w=800",
    after: "https://images.unsplash.com/photo-1526392587392-d1627b6c134a?crop=entropy&cs=srgb&fm=jpg&q=80&w=800",
  },
  {
    label: "Hazard Removed, Yard Restored",
    before: "https://images.unsplash.com/photo-1645466996104-22f4b160331b?crop=entropy&cs=srgb&fm=jpg&q=80&w=800",
    after: "https://images.unsplash.com/photo-1628340981113-fe1949fe5cc0?crop=entropy&cs=srgb&fm=jpg&q=80&w=800",
  },
];


